import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

const IconDashboard = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
  </svg>
);

const IconTable = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18" strokeLinecap="round"/>
  </svg>
);

const IconOrders = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
    <line x1="8" y1="18" x2="21" y2="18"/>
    <circle cx="3" cy="6" r="1" fill="currentColor"/>
    <circle cx="3" cy="12" r="1" fill="currentColor"/>
    <circle cx="3" cy="18" r="1" fill="currentColor"/>
  </svg>
);

const IconMenu = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z"/>
    <path d="M12 6v6l4 2"/>
  </svg>
);

const IconSettings = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const IconPhone = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="5" y="2" width="14" height="20" rx="2"/>
    <line x1="12" y1="18" x2="12" y2="18" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

const IconStore = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const IconUser = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const IconLogout = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

const IconHamburger = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const IconChart = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);

const IconBellNav = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
);

const IconTag = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);

const NAV_ITEMS = [
  { section: '운영', items: [
    { path: '/dashboard', icon: <IconDashboard />, label: '대시보드' },
    { path: '/tables', icon: <IconTable />, label: '테이블' },
    { path: '/orders', icon: <IconOrders />, label: '주문', hasBadge: true },
    { path: '/menu', icon: <IconMenu />, label: '메뉴' },
    { path: '/allergens', icon: <IconMenu />, label: '알레르기/원산지' },
    { path: '/staff-calls', icon: <IconBellNav />, label: '직원 호출', hasStaffBadge: true },
    { path: '/coupons', icon: <IconTag />, label: '쿠폰' },
  ]},
  { section: '결제/정산', items: [
    { path: '/refunds', icon: <IconTag />, label: '환불 관리' },
    { path: '/receipts', icon: <IconTag />, label: '영수증' },
    { path: '/settlement', icon: <IconChart />, label: '정산' },
    { path: '/billing', icon: <IconTag />, label: '구독/요금제' },
  ]},
  { section: '분석', items: [
    { path: '/reports', icon: <IconChart />, label: '매출 리포트' },
    { path: '/monitoring', icon: <IconChart />, label: '시스템 모니터링' },
  ]},
  { section: '관리', items: [
    { path: '/kyc', icon: <IconStore />, label: '사업자 인증' },
    { path: '/notification-settings', icon: <IconBellNav />, label: '알림 설정' },
    { path: '/help', icon: <IconUser />, label: '도움말' },
    { path: '/settings', icon: <IconSettings />, label: '설정' },
  ]},
];

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const [staffCallCount, setStaffCallCount] = useState(0);

  // Fetch pending orders count
  useEffect(() => {
    if (!user?.storeId) return;

    const fetchPendingCount = async () => {
      try {
        const res = await api.get(`/stores/${user.storeId}/orders?status=pending&limit=1`);
        const count = res.data?.total || res.data?.count || 0;
        setPendingCount(count);
      } catch {
        setPendingCount(0);
      }
    };

    const fetchStaffCallCount = async () => {
      try {
        const res = await api.get(`/admin/staff-calls/${user.storeId}`);
        const data = res.data;
        const list = Array.isArray(data) ? data : data.calls || data.staffCalls || [];
        setStaffCallCount(list.filter((c) => c.status === 'pending').length);
      } catch {
        setStaffCallCount(0);
      }
    };

    fetchPendingCount();
    fetchStaffCallCount();
    const interval = setInterval(fetchPendingCount, 30000);
    const interval2 = setInterval(fetchStaffCallCount, 10000);
    return () => { clearInterval(interval); clearInterval(interval2); };
  }, [user?.storeId]);

  // Close sidebar on navigation on mobile
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const storeName = user?.name || user?.storeName || user?.store_name || '내 가게';
  const email = user?.email || '';

  return (
    <>
      {/* Mobile hamburger button */}
      <button
        className="hamburger-btn"
        onClick={() => setIsOpen(true)}
        aria-label="메뉴 열기"
      >
        <IconHamburger />
      </button>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon" style={{ color: '#fff' }}><IconPhone /></div>
          <span className="sidebar-logo-text">스마트오더</span>
        </div>

        {/* Store badge */}
        <div className="sidebar-store-badge">
          <IconStore />
          <span className="store-name">{storeName}</span>
        </div>

        {/* Navigation */}
        <div className="sidebar-nav">
          {NAV_ITEMS.map((section) => (
            <div key={section.section} className="nav-section">
              <div className="nav-section-title" style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-tertiary)', padding: '12px 16px 6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {section.section}
              </div>
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                  {item.hasBadge && pendingCount > 0 && (
                    <span className="nav-badge">{pendingCount > 99 ? '99+' : pendingCount}</span>
                  )}
                  {item.hasStaffBadge && staffCallCount > 0 && (
                    <span className="nav-badge">{staffCallCount > 99 ? '99+' : staffCallCount}</span>
                  )}
                </NavLink>
              ))}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="user-avatar"><IconUser /></div>
            <span className="user-email">{email}</span>
          </div>
          <button className="logout-btn" onClick={logout}>
            <IconLogout />
            <span>로그아웃</span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
